var map = {
	"./audio.json": 800194,
	"./drag_and_drop.json": 341440,
	"./fill_the_blanks_v2.json": 44026,
	"./find_hotspot.json": 982347,
	"./geogebra_graphing.json": 449041,
	"./labelling.json": 163218,
	"./matching.json": 10523,
	"./multi_choice_v2.json": 405078,
	"./multi_part_v2.json": 631132,
	"./section.json": 985139,
	"./separator.json": 55619,
	"./table.json": 811056,
	"./text_box.json": 579929,
	"./text_response_v3.json": 308415,
	"./true_false_v2.json": 412073,
	"./video.json": 142663,
	"./workbook_drawing.json": 971069
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55863;